import type { Transaction } from '@api/hooks/types/getTransactions';
import { useBankProfile } from '@contexts/BankProfileContext';
import { useAuth } from '@hooks/useAuth';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export const useTransactionDetail = (transactionId: string) => {
	const { session } = useAuth();
	const { selectedProfile } = useBankProfile();

	const fetchTransactionDetails = async (): Promise<Transaction> => {
		const response = await axios.get(
			`${import.meta.env.VITE_API_HOST}/api/v1/profiles/${selectedProfile.id}/transactions/${transactionId}`,
			{
				headers: { Authorization: session?.tokenized },
			},
		);

		return response.data;
	};

	return useQuery({
		queryKey: ['transactions', selectedProfile?.id, transactionId],
		queryFn: fetchTransactionDetails,
		enabled: !!selectedProfile?.id && !!transactionId,
		select: (data) => ({
			...data,
			amount: data.amount / 100,
		}),
	});
};
